<template>
  <Html data-theme="light" />
  <KernelApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </KernelApp>
</template>

<script setup lang="ts">
import { titleCase } from 'scule'
import type { PageName } from './config'
import { CommunicationManager } from './services/communicationManager'

const route = useRoute()
const { userRoles } = useUser()

useSentry()

const previousUserGroups = ref(userRoles.value)

const { locale } = useI18n()

onMounted(() => {
  // activate page must be called during setup of this component, else, services cannot import from composables
  CommunicationManager.activatePage(route.name as PageName)
})

watch(
  () => userRoles.value,
  async (value) => {
    if (value.length === 0) {
      return
    }

    if (areArraysEqual(value, previousUserGroups.value)) {
      return
    }

    previousUserGroups.value = value

    // nextTick is needed to wait for the page to be rendered after changing the userGroups
    // after the page is rendered, we can activate the page to obtain data from the services
    await nextTick()

    CommunicationManager.activatePage(route.name as PageName)
  },
)

function areArraysEqual<T>(arr1: T[], arr2: T[]): boolean {
  return arr1.every((val, index) => val === arr2[index])
}

watch(
  () => route.name,
  (value) => {
    CommunicationManager.activatePage(value as PageName)
  },
)

useHead({
  titleTemplate: (title?: string) => {
    if (!title) {
      return 'Mais 🌽 | MedApp'
    }
    const titleParts = ['🌽']

    // take advantage of the fact that the urls are in Dutch. Newer pages should translate and override this template function.
    const firstPath = route.path.split('/').at(1)
    if (firstPath) {
      titleParts.push(titleCase(firstPath))
    }

    titleParts.push(title)

    return titleParts.join(' > ')
  },

  htmlAttrs: {
    lang: locale,
  },
})
</script>
